var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 53,
    viewBox: "0 0 63 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4071 37.4351C21.3982 42.7233 17.1038 47.0117 11.8134 47.0117C6.52304 47.0117 2.24314 42.7233 2.2521 37.4351C2.26106 32.1469 6.5555 27.8585 11.8459 27.8585C17.1362 27.8585 21.4161 32.1469 21.4071 37.4351Z",
    stroke: "#F3AA47",
    strokeWidth: 2.84583
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9023 26.4831C60.8794 40.0555 49.858 51.0597 36.2833 51.0597C22.7087 51.0597 11.7244 40.0555 11.7473 26.4831C11.7702 12.9106 22.7916 1.90648 36.3663 1.90648C49.9409 1.90648 60.9252 12.9106 60.9023 26.4831Z",
    stroke: "#F3AA47",
    strokeWidth: 2.84583
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.0ae46c92351e505e6d175e532383772a.svg";
export { ForwardRef as ReactComponent };